import { Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

export const BackToLogin: React.FC = () => (
  <Stack
    direction="row"
    spacing={1}
    justifyContent="center"
    padding={2}
    bgcolor="#0D1B270A"
    borderRadius={1}
  >
    <Link to="/login">
      <Typography
        variant="body1"
        fontWeight={300}
        color="#1B3D5599"
        fontSize={16}
      >
        Back to login
      </Typography>
    </Link>
  </Stack>
);